import React from 'react';
import { authRoles, PERMISSION } from 'app/auth';
import i18next from 'i18next';
import { MENU_ENUM } from 'app/main/role/constants';
import en from '../i18n/en';

i18next.addResourceBundle('en', 'announcement', en);

const CreateAnnouncementConfig = {
  settings: {
    layout: { config: {} },
    nav: { title: 'Create Announcement' },
  },
  auth: authRoles.user,
  key: MENU_ENUM.ANNOUNCEMENT,
  permission: PERMISSION.CREATE,
  routes: [
    {
      path: '/announcement/create',
      component: React.lazy(() => import('./CreateAnnouncement')),
    },
  ],
};

export default CreateAnnouncementConfig;
